const RankingReferralClient = (json: IRankingReferralClient): IRankingReferralClientModel => {
	const { id, uuid, email } = json

	return {
		id,
		uuid,
		email,
	}
}

export const RankingReferral = (json: IRankingReferral): IRankingReferralModel => {
	const { id, uuid, client_id, first_name, last_name, referrals_count, client } = json

	return {
		id,
		uuid,
		clientID: client_id,
		firstName: first_name,
		lastName: last_name,
		referralsCount: referrals_count,
		client: client ? RankingReferralClient(client) : null,
	}
}
